import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Meta from "vue-meta";
import ClinicsResult from "@/views/ClinicsResult/ClinicsResult.vue";
import Home from "../views/Home/Home.vue";
import SearchError from "../views/SearchError.vue";
import ClinicScreen from "@/views/ClinicScreen/HomeClinic.vue";
import NotFoundPage from "@/views/NotFound/NotFoundPage.vue";
import RatingPage from "@/views/Rating/RatingPage.vue";
import SearchBarIframe from "@/views/SearchBarIframe/SearchBarIframe.vue";
import { getEnvVariable } from "@/api/axios";

Vue.use(VueRouter);
Vue.use(Meta);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    async beforeEnter(to, from, next) {
      const VUE_APP_IS_PRODUCTION = await getEnvVariable("VUE_APP_IS_PRODUCTION");
      
      VUE_APP_IS_PRODUCTION === "true" 
        ? window.location.href = "https://saude.clinicarx.com.br" 
        : next()
    }
  },
  {
    path: "/r/:serviceName",
    name: "SearchServices",
    component: ClinicsResult,
    props: true,
  },
  {
    path: "/r/:slugId",
    name: "SearchServicesTenancy",
    component: ClinicsResult,
    props: true,
  },
  {
    path: "/onde-encontrar/:slugId/:clinicId",
    name: "ClinicScreen",
    component: ClinicScreen,
  },
  {
    path: "/search-error",
    name: "SearchError",
    component: SearchError,
  },
  {
    path: "/onde-encontrar/:slugId",
    name: "Tenancy",
    component: Home,
  },
  {
    path: "/search/:fileName",
    name: "SEOSearchServicesTenancy",
    component: ClinicsResult,
    props: true,
  },
  {
    path: "/avaliacao/atendimento/:appointmentId/:rating/:env",
    name: "RatingPage",
    component: RatingPage,
  },
  {
    path: "/iframe/search-bar",
    name: "SearchBarIframe",
    component: SearchBarIframe,
  },
  {
    path: "*",
    name: "NotFoundPage",
    component: NotFoundPage,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
